import { MenuItem, Select } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { get } from 'lodash'

interface ContestSubtypeSelectProps {
  name: string
  types: string[]
  disabled: boolean
}

const getContestSubtypeLabel = (value: string) => {
  if (value === 'Location') {
    return 'Location(s)'
  }

  if (value === 'CombinedLocations') {
    return 'Combined Locations'
  }

  return value.replace(/([A-Z])/g, ' $1').replace(/^ +/, '')
}

export const ContestSubtypeSelect = ({
  name,
  types,
  disabled,
}: ContestSubtypeSelectProps) => {
  const {
    control,
    formState: { defaultValues },
  } = useFormContext()
  const defaultValue = get(defaultValues, name)

  return (
    <Controller
      render={({ field }) => (
        <Select
          {...field}
          labelId={name}
          variant="outlined"
          fullWidth
          disabled={disabled}
          defaultValue={defaultValue}
          id={name}
        >
          {types.map((status) => (
            <MenuItem value={status} key={status}>
              {getContestSubtypeLabel(status)}
            </MenuItem>
          ))}
        </Select>
      )}
      name={name}
      control={control}
      defaultValue={defaultValue}
    />
  )
}
